module.exports = __webpack_public_path__ + "static/media/2DGACM10.c022e559.jpg";